import React, { useEffect, useState } from 'react';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import { documentService } from '../../../../api/services/documentService';
import _ from 'lodash';
import CardfordownloadEditViewAction from '../../../components/CardfordownloadEditViewAction/CardfordownloadEditViewAction';
import DownloadDocController from '../../../../domain/myProfile/documents/DownloadDocs/DownloadDocController';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  docdata?: any;
}
const ViewDocHistoryPresenter = ({
  isModalOpen,
  closeModal,
  trans,
  docdata,
}: ModalProps) => {
  const [docdetils, setDocdetails] = useState([]);
  const [attachmentUrl, setAttachmentUrl] = useState('');
  const [open_modal, setOpenModal] = useState(false);

  useEffect(() => {
    const DocID = docdata?.id;
    const EmpID = docdata?.emp_id;
    callgetEmpDocHistory(DocID, EmpID);
    //
  }, [docdata]);
  async function callgetEmpDocHistory(DocID: number, EmpID: number) {
    await documentService
      .getEmpDocHistory(DocID, EmpID)
      .then((res) => {
        setDocdetails(res?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  const handleViewNDownload = (data: any) => {
    getAttchedDocs(data);
  };
  const full_path = '';
  const getAttchedDocs = async (data: any) => {
    const response: any = await documentService.getAttachedDoc_histroy(data);

    if (response.response == 'success') {
      const url = response.data.attachment;
      if (url != null) {
        setAttachmentUrl(url);
        setOpenModal(true);
      } else {
        //toast.error(t('There is no Attached file'));
      }
    }
  };
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Documents History') }}
        closeModal={closeModal}
      />
      {docdetils.length > 0 &&
        _.map(docdetils, (Docs: any) => {
          return (
            <CardfordownloadEditViewAction
              key={Docs?.id}
              tile_value={Docs?.type}
              //subtitle1={`${trans('Identifier No')}: `}
              IdentifierNo={Docs?.identifier_number}
              Issuetitle={trans('Issue')}
              IssueDate={Docs?.issue_date}
              Expirytitle={trans('Expiry')}
              ExpDate={Docs?.validity_date}
              country={Docs?.issue_country}
              //onEdit={() => handleEditDocuments(Docs)}
              //onDelete={() => handleDeleteModal(Docs)}
              onView={() => handleViewNDownload(Docs?.id)}
            />
          );
        })}
      {open_modal && (
        <DownloadDocController
          isModalOpen={open_modal}
          closeModal={() => setOpenModal(false)}
          attachmentUrl={attachmentUrl}
        />
      )}
    </CustomModal>
  );
};
export default ViewDocHistoryPresenter;
